import React from 'react'
import cochez from '../../assets/cochez.svg'
import novey from '../../assets/novey.svg'
import { useCustomerDisplay } from '../../context/CustomerDisplayContext'
import { validatorCompany } from '../../utils/validatorCompany'
import './fallbackLogo.css'

export default function FallbackLogo() {
  const { company } = useCustomerDisplay()
  const companySelected = validatorCompany(company)

  const getBackgroundColor = () => {
    if (companySelected === 'CO') return '#FFEE00'
    if (companySelected === 'NO') return '#0055B8'
    return '#FFEE00'
  }

  const getLogo = () => {
    if (companySelected === 'CO') return cochez
    if (companySelected === 'NO') return novey
    return cochez
  }

  return (
    <div
      className="fallback-logo-container"
      data-testid="container-fallback-logo"
      style={{ backgroundColor: getBackgroundColor() }}>
      <img
        data-testid="img-company-logo"
        className="fallback-logo-image"
        src={getLogo()}
        alt="Company Logo"
      />
    </div>
  )
}
